// @ts-check
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { ListItemSecondaryAction } from '@material-ui/core';

import ListItemAvatar from '@material-ui/core/ListItemAvatar/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar/Avatar';
import IconButton from '@material-ui/core/IconButton/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import EmailIcon from '@material-ui/icons/Email';
import CallIcon from '@material-ui/icons/Call';
import { EditUserFormValidation } from './edit-user-component';
import Typography from '@material-ui/core/Typography/Typography';
import { UserPasswordComponent } from './user-password-component';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    // marginTop: theme.spacing(0),
    marginBottom: theme.spacing(1)
  },
  heading: {
    margin: theme.spacing(2)
  }
}));

function Mail({ user }) {
  const classes = useStyles();

  return (
    <List className={classes.root}>
      <ListItem>
        <ListItemText primary={<small>Email</small>} secondary={user.email}></ListItemText>

        <ListItemSecondaryAction>
          <IconButton edge="end" aria-label="vie key">
            <EmailIcon />
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
    </List>
  );
}

function Call({ user }) {
  const classes = useStyles();

  return (
    <List className={classes.root}>
      <ListItem>
        <ListItemText primary={<small>Phone no.</small>} secondary={user.mobile_no}></ListItemText>

        <ListItemSecondaryAction>
          <IconButton edge="end" aria-label="vie key">
            <CallIcon />
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
    </List>
  );
}

function UserDetails({ user }) {
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <List className={classes.root}>
        <ListItem>
          <ListItemAvatar>
            <Avatar alt={user.name} src="/static/images/avatar/1.jpg" />
          </ListItemAvatar>
          <ListItemText primary={`${user.name}`} secondary={null}></ListItemText>

          <ListItemSecondaryAction>
            {!open && (
              <IconButton edge="end" aria-label="comments" onClick={handleClickOpen}>
                <EditIcon />
              </IconButton>
            )}
            {open && (
              <IconButton edge="end" aria-label="comments" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            )}
          </ListItemSecondaryAction>
        </ListItem>
      </List>

      {open && <EditUserFormValidation user={user} handleClose={handleClose} />}
    </>
  );
}

export function UserStatusComponent({ user }) {
  const classes = useStyles();

  return (
    <>
      <UserDetails user={user} />

      <UserPasswordComponent user={user} />

      <>
        <Typography variant="subtitle2" component="h3" align="center" className={classes.heading}>
          <small>
            <b>Contact Details</b>
          </small>
        </Typography>
        <Mail user={user} />
        <Call user={user} />
      </>
    </>
  );
}
